module.exports = __webpack_public_path__ + "img/download-google-play.1259e378.svg";